import { DragType } from '@/components/table/Table';

import { ReactNode } from 'react';
import { styled } from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';

export const DragHandle = (props: {
  dragType: DragType;
  dragId: string;
  index: number;
  metadata?: Record<string, any>;
  children: ReactNode;
}) => {
  const {
    dragType = DragType.ROW,
    dragId,
    index,
    metadata,
    children,
    ...rest
  } = props;
  const { attributes, listeners, setNodeRef } = useSortable({
    id: dragId,
    data: { index, type: dragType, ...(metadata ?? {}) },
  });

  return (
    <DraggableHandle ref={setNodeRef} {...attributes} {...listeners} {...rest}>
      {children}
    </DraggableHandle>
  );
};

const DraggableHandle = styled('div')`
  display: flex;
  align-items: center;

  &:hover {
    cursor: grab;
  }
`;
